const Blocks = (state = { assetManifest: {}, dataUrl: null }, action) => {
  switch (action.type) {
    case 'DATA_URL':
      return {
        ...state,
        dataUrl: action.dataUrl
      };
    case 'UPDATE_DATA_URL':
      return {
        dataUrl: action.dataUrl
      };
    case 'INIT_DATA':
      return {
        ...state,
        ...action,
        display: action.display,
        blockJsonData: action.blockJsonData,
        assetManifest: action.assetManifest,
        dataLoadComplete: action.dataLoadComplete
      };
    case 'RESET_COURSE':
      return { assetManifest: {}, dataUrl: null };
    default:
      return state;
  }
};
export default Blocks;
